//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { matchPath } from "react-router";

// filter routes func
function FilterRoutes(customRoutes, allowedRoutes) {
  let filteredRoutes = [];
  customRoutes.map((element) => {
    allowedRoutes.find((route) => {
      if (matchPath(element.props?.path, route) || element.to === route.path) {
        filteredRoutes.push(element);
      }
    });
  });
  return filteredRoutes;
}

export default FilterRoutes;
